import { useRouter } from 'next/router';
import { RnMessage, sendToRN } from '@/utils/function';
import { useRecorder } from '@/components/RecorderProvider';
import { useDialog } from '@/hooks/global-tools';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useReload = () => {
  const router = useRouter();
  const { isRecordingInProgress, stop } = useRecorder();
  const dialog = useDialog();
  const { t } = useTranslation();

  // 다른 값 업데이트 후 리로드를 실행하기 위해 사용
  const [reloadTick, setReloadTick] = useState(false);

  useEffect(() => {
    if (reloadTick) {
      handleReload();
      setReloadTick(false);
    }
  }, [reloadTick]);

  const handleReload = () => {
    if (window.isRNWebview) {
      sendToRN(RnMessage.RESTART);
    } else {
      router.reload();
    }
  };

  const reload = async (
    action?: () => void | Promise<void>,
    waitForAction = true,
  ) => {
    const executeAction = async () => {
      if (action) {
        if (waitForAction) {
          await action();
        } else {
          action();
        }
      }
    };

    if (isRecordingInProgress) {
      dialog.show({
        type: 'confirm',
        title: '',
        message: `${t('지금 녹음 중이에요.')}\n${t(
          '계속 진행하면 녹음이 중단돼요.',
        )}`,
        onConfirm: async () => {
          stop();
          await executeAction();
          setReloadTick(true);
        },
        confirmButtonText: t('계속'),
        isBlockBackDropClose: true,
      });
    } else {
      await executeAction();
      handleReload();
    }
  };

  return {
    reload,
  };
};
